// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { notification } from "antd";
import { http } from "../../../engine/api/http";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import routes from "../../../engine/routes";
import dayjs from "../../../utils/dayjs";

const initialState = {
  user: {
    info: {
      firstname: "",
      lastname: "",
      phone: "",
      genre: "",
    },
    institution: null,
    email: "",
    _id: undefined,
    archived: false,
  },
  loading: false,
};

const slicename = "userControl";

export const getUser = createAsyncThunk(
  `${slicename}/getBill`,
  async (userId, thunkAPI) => {
    const res = await http.get("/users/" + userId);
    return res.data;
  },
);

export const updateUser = createAsyncThunk(
  `${slicename}/update`,
  async (payload, thunkAPI, state) => {
    const user = thunkAPI.getState().userControl.user;

    if (user._id !== undefined) {
      const res = await http.patch("/users/" + user._id, user);
      notification.success({
        message: `Utilisateur modifié`,
      });
      console.log(res.data);
      return res.data;
    } else {
      const res = await http.post("/users/new", user);
      // thunkAPI.dispatch(updateUserOnList(res.data));
      notification.success({
        message: `Utilisateur Crée`,
      });
      console.log(res.data);
      return res.data;
    }
  },
);

const userSlice = createSlice({
  name: `${slicename}`,
  initialState,
  reducers: {
    clearUser: state => {
      return initialState;
    },
    setPropertiesUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
  },
  extraReducers: {
    [getUser.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getUser.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.user = payload;
    },
    [updateUser.pending]: (state, { payload }) => {},
    [updateUser.fulfilled]: (state, { payload }) => {
      state.user = payload;
    },
    [updateUser.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [getUser.rejected]: state => {
      state.loading = false;
    },
  },
});

export const initUserSlice = ({ id }) => {
  const dispatch = useDispatch();

  const { user } = useSelector(state => state.userControl);
  const navigate = useNavigate();

  const init = () => {
    if (user._id !== id && id !== "new") {
      dispatch(getUser(id));
    }
  };

  const clear = () => {
    dispatch(clearUser());
  };

  useEffect(() => {
    if (user._id !== undefined && id === "new") {
      navigate(routes.users(user._id).detail.path, {
        replace: true,
      });
    }
  }, [user]);

  useEffect(() => {
    init();

    if (id === "new" && user._id !== undefined && user._id !== id) {
      // Reset when go to a new one
      clear();
      navigate(routes.users().new.path, {
        replace: true,
      });
    }

    return () => {
      // cleanup when leave
      if (user._id === undefined) {
        clear();
      }
      // clear();
    };
  }, []);

  return { init, clear };
};

export const {
  addNewTimeInSchedule,
  updateTimeSchedule,
  pushNewSchdedule,
  clearUser,
  setPropertiesUser,
  updateValuesSchdedule,
  removeScheduleDate,
} = userSlice.actions;

export const userInitialState = initialState;

export const userControlReducer = userSlice.reducer;
